import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { Grid, Box, LinearProgress, Typography } from '@material-ui/core';
import StatBoxSlim from "components/Stats/StatBoxSlim";
import * as H from "helper";

const useStyles = makeStyles((theme) =>
  createStyles({
    lblPercent: {
      marginTop: 32,
      flexGrow: 1,
      textAlign: "right",
      fontSize: 13,
    },
    tooltip: {
      position: 'absolute',
      top: '8px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '5px 10px',
      borderRadius: '4px',
      fontSize: '14px',
      whiteSpace: 'nowrap',
    },
  })
);

const PhotoShoot = ({
  dateRange,
  homeDataPhotoShoot,
  homeDataPhotoShootBySeason,
  selectedSeason,
  seasonData,
}) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      <Grid item m={12} md={8} lg={10}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="総写真数"
                  value={homeDataPhotoShoot.countPic !== undefined ? homeDataPhotoShoot.countPic  : "-"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="総基数"
                  value={homeDataPhotoShoot.countAsset !== undefined ? homeDataPhotoShoot.countAsset  : "-"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="レビューOK基数"
                  tip="レビューOKのユニーク基数"
                  value={homeDataPhotoShoot.countReviewOk !== undefined ? homeDataPhotoShoot.countReviewOk  : "-"}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="電柱基数"
                  value={homeDataPhotoShoot.countDenchu !== undefined ? homeDataPhotoShoot.countDenchu  : "-"}
                  vsExtra={homeDataPhotoShoot.countDupeDenchu !== undefined ? `(重複数: ${homeDataPhotoShoot.countDupeDenchu})`  : null}
                  tip="ユニークの電柱基数"
                  valueExtra={`達成率: ${
                    homeDataPhotoShootBySeason.totalRatio !== undefined
                    ? `${homeDataPhotoShootBySeason.totalRatio.denchu}%<br />
                      登録数：${H.FormatNumStrHelper.formatCommaThousand(homeDataPhotoShootBySeason.totalCountByAsset.denchu)}`
                    : "--"}`
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="換気口基数"
                  value={homeDataPhotoShootBySeason.totalCounts !== undefined ? homeDataPhotoShootBySeason.totalCounts.kankiko : "-"}
                  vsExtra={homeDataPhotoShoot.countDupeKankiko !== undefined
                    ? `(重複数: ${selectedSeason.length > 1 ? "n/a" : homeDataPhotoShoot.countDupeKankiko})`
                    : null}
                  tip="ユニークの換気口基数"
                  valueExtra={`達成率: ${
                    homeDataPhotoShootBySeason.totalRatio !== undefined
                    ? `${homeDataPhotoShootBySeason.totalRatio.kankiko}%<br />
                      登録数：${H.FormatNumStrHelper.formatCommaThousand(homeDataPhotoShootBySeason.totalCountByAsset.kankiko)}`
                    : "--"}`
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="地上設備基数"
                  value={homeDataPhotoShootBySeason.totalCounts !== undefined ? homeDataPhotoShootBySeason.totalCounts.ground_equipment : "-"}
                  vsExtra={homeDataPhotoShoot.countDupeGroundEquip !== undefined
                    ? `(重複数: ${selectedSeason.length > 1 ? "n/a" : homeDataPhotoShoot.countDupeGroundEquip})`
                    : null}
                  valueExtra={`達成率: ${
                    homeDataPhotoShootBySeason.totalRatio !== undefined
                    ? `${homeDataPhotoShootBySeason.totalRatio.ground_equipment}%<br />
                      登録数：${H.FormatNumStrHelper.formatCommaThousand(homeDataPhotoShootBySeason.totalCountByAsset.ground_equipment)}`
                    : "--"}`
                  }
                />
              </Grid>
              {homeDataPhotoShootBySeason.totalCounts !== undefined && homeDataPhotoShootBySeason.totalCounts.mh > 0 &&
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="MH基数"
                  value={homeDataPhotoShootBySeason.totalCounts !== undefined ? homeDataPhotoShootBySeason.totalCounts.mh  : "-"}
                  vsExtra={homeDataPhotoShoot.countDupeMh !== undefined
                    ? `(重複数: ${selectedSeason.length > 1 ? "n/a" : homeDataPhotoShoot.countDupeMh})`
                    : null}
                  valueExtra={`達成率: ${
                    homeDataPhotoShootBySeason.totalRatio !== undefined
                    ? `${homeDataPhotoShootBySeason.totalRatio.mh}%<br />
                      登録数：${H.FormatNumStrHelper.formatCommaThousand(homeDataPhotoShootBySeason.totalCountByAsset.mh)}`
                    : "--"}`
                  }
                />
              </Grid>
              }
              {homeDataPhotoShootBySeason.totalCounts !== undefined && homeDataPhotoShootBySeason.totalCounts.hh > 0 &&
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="HH基数"
                  value={homeDataPhotoShootBySeason.totalCounts !== undefined ? homeDataPhotoShootBySeason.totalCounts.hh  : "-"}
                  vsExtra={homeDataPhotoShoot.countDupeHh !== undefined
                    ? `(重複数: ${selectedSeason.length > 1 ? "n/a" : homeDataPhotoShoot.countDupeHh})`
                    : null}
                  valueExtra={`達成率: ${
                    homeDataPhotoShootBySeason.totalRatio !== undefined
                    ?  `${homeDataPhotoShootBySeason.totalRatio.hh}%<br />
                      登録数：${H.FormatNumStrHelper.formatCommaThousand(homeDataPhotoShootBySeason.totalCountByAsset.hh)}`
                    : "--"}`
                  }
                />
              </Grid>
              }
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="撮影者数"
                  value={homeDataPhotoShoot.countUniqueUser !== undefined ? homeDataPhotoShoot.countUniqueUser  : "-"}
                  lastItem={true}
                  tip="ユニークの撮影者数"
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <StatBoxSlim
                  title="初回撮影者数"
                  value={homeDataPhotoShoot.countNewUser !== undefined ? homeDataPhotoShoot.countNewUser  : "-"}
                  lastItem={true}
                  tip="過去のシーズン含み、初めて撮影したユーザー数"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item m={12} md={4} lg={2}>
        {homeDataPhotoShoot.progressDenchu !== undefined &&
        <>
        <Typography variant="body2">{`
        ${dateRange[0]} ~ ${dateRange[1]} 時点のアセット撮影達成率`}</Typography>
        <div className={classes.lblPercent}>
          <Box width="100%" position="relative">
            <Box className={classes.tooltip}>
              {homeDataPhotoShoot.countReviewOk !== undefined &&
              `${Math.round(homeDataPhotoShoot.countReviewOk)}
              (${((homeDataPhotoShoot.countReviewOk / homeDataPhotoShoot.progressDenchu.maxByasset) * 100).toFixed(2)}%)`
              }
            </Box>
            <Box>
              <LinearProgress variant="determinate" value={
                homeDataPhotoShoot.countReviewOk !== undefined
                ? (homeDataPhotoShoot.countReviewOk / homeDataPhotoShoot.progressDenchu.maxByasset) * 100
                : 0
              }
              />
            </Box>
            <Box display="flex" justifyContent="space-between" mt={1}>
              <Typography variant="body2" color="textSecondary">0</Typography>
              <Typography variant="body2" color="textSecondary">
                {homeDataPhotoShoot.progressDenchu.max !== undefined ? homeDataPhotoShoot.progressDenchu.max : "--"}
              </Typography>
            </Box>
          </Box>
        </div>
        </>
        }
      </Grid>
    </Grid>
  );
};

PhotoShoot.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dateRange: state.page.dateRangePicTree,
  homeDataPhotoShoot: state.pictree.homeDataPhotoShoot,
  selectedSeason: state.pictree.selectedSeason,
  seasonData: state.pictree.seasonData,
  homeDataPhotoShootBySeason: state.pictree.homeDataPhotoShootBySeason,
});

const mapDispatchToProps = (dispatch) => ({
  //setCurrentModule: (param) => dispatch(setCurrentModule(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(PhotoShoot));
